// 9fbef606107a605d69c0edbcd8029e5d
const pink = {
  200: '#e2499b',
  400: '#f78cc6',
  500: '#df4b9a',
  600: '#d564a1',
  700: '#ffa4a9',
  319: '#E20099'
};

export default pink;
